import { WAYPOINT_DECIMAL_PLACES } from './constants';

/** Degrees rounded to the precision route waypoints are stored at */
export const roundToWaypointPrecision = (degrees: number) => Number(degrees.toFixed(WAYPOINT_DECIMAL_PLACES));

/** Whether a waypoint is at exactly a place, compared at the precision route waypoints are stored at */
export const isWaypointAt = ({ latitude, longitude }: { latitude: number; longitude: number }, lat: number, lng: number) =>
  roundToWaypointPrecision(latitude) === roundToWaypointPrecision(lat) && roundToWaypointPrecision(longitude) === roundToWaypointPrecision(lng);
